<template>
  <div class="line-frame" :class="positionClass">
    <div class="line-frame-title" v-if="title">
      {{ title }}
    </div>
    <div class="line-frame-action line-frame-action-right">
      <div v-if="action">
        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
          <i
            class="el-icon-remove-outline"
            style="font-size: 20px;color: red;cursor: pointer"
            @click="$emit('removeFrame')"
          />
        </el-tooltip>
      </div>
      <div v-if="addAction">
        <el-tooltip class="item" effect="dark" content="新增" placement="top-start">
          <i
            class="el-icon-circle-plus-outline cor409EFF"
            style="font-size: 20px;"
            @click="$emit('addFrame')"
          />
        </el-tooltip>
      </div>
    </div>
    <div class="line-frame-content" :class="contentClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      action: {
        type: Boolean,
        default: false,
      },
      addAction: {
        type: Boolean,
        default: false,
      },
      position: {
        type: String,
        default: 'left',
        validator: (value) => ['left', 'right'].includes(value),
      },
      contentClass: {
        type: String,
        default: '',
      },
    },
    name: 'LineFrame',
    computed: {
      positionClass() {
        return `line-frame-${this.position}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .line-frame {
    position: relative;
    padding: 20px;
    margin: 20px 0;
  }

  .line-frame-title {
    position: absolute;
    top: -8px;
    background-color: white;
    padding: 0 10px;
    font-size: 15px;
    font-weight: bold;
  }

  .line-frame-action {
    position: absolute;
    top: -8px;
    background-color: white;
    padding: 0 10px;
    font-size: 15px;
    font-weight: bold;
    display: flex;
    gap: 5px;
    &-right {
      right: 15px;
    }
  }

  .line-frame-left .line-frame-title {
    left: 10px;
  }

  .line-frame-right .line-frame-title {
    right: 15px;
  }
</style>
